/**
 * Checks if an url is a valid youtube link
 * This Does not allow playlists or `music.` subdomains
 * @param url
 */
export function isValidYoutubeLink(url: string) {
  if (!url) return false;
  try {
    const parsedUrl = new URL(
      url.startsWith('https://') || url.startsWith('http://')
        ? url
        : `https://${url}`
    );

    const hostname = parsedUrl.hostname.toLowerCase();

    if (hostname.startsWith('music.')) {
      return false;
    }

    if (
      hostname === 'youtu.be' ||
      hostname.endsWith('youtube.com') ||
      hostname.endsWith('youtube-nocookie.com') ||
      hostname === 'youtube-education.com'
    ) {
      if (parsedUrl.pathname.includes('/live/')) return false;
      if (parsedUrl.pathname.includes('/playlist')) return false;

      // https://developers.google.com/youtube/player_parameters#list
      if (parsedUrl.searchParams.get('list')) return false;

      // Every youtube video has a video id. However it can be in a lot of different places.
      // To work around that, use this regex to find the video id.
      const matches = parsedUrl.toString().match(/^.*[a-zA-Z0-9_-]{11}/);
      return !!matches;
    }

    return false;
  } catch (error) {
    return false;
  }
}
